// File Metadata:
// Filename: NewVendor.js
// Version: 1.00
// Created: 2022-10-13 22:59:28
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import NewVendorForm from './NewVendorForm'

const NewVendor = () => {
	const content = <NewVendorForm />

	return content
}

export default NewVendor
